import { render } from "./management-accounts-modal.vue?vue&type=template&id=68431bf8"
import script from "./management-accounts-modal.vue?vue&type=script&lang=js"
export * from "./management-accounts-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__